import React from 'react'
import { PlugZap, KeyRound } from 'lucide-react'

const MCP_URL = import.meta.env.VITE_MCP_CONNECTOR_URL

export default function AccountPage() {
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>Account</h1>
        <p>Internal tools and connections for staff accounts.</p>
      </div>

      <div className="card" style={{ padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          <PlugZap size={18} style={{ color: 'var(--accent)' }} />
          <h3 style={{ margin: 0, fontSize: 16 }}>Connect Claude to the internal MCP server</h3>
        </div>
        <p style={{ margin: '4px 0 18px', fontSize: 13, color: 'var(--text-muted)' }}>
          This lets Claude read internal data (leads, events) on your behalf, using your own
          company login. There's nothing to register or create ahead of time — the connector
          registers itself the first time you connect.
        </p>

        <div style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 8,
          padding: 12,
          marginBottom: 20,
        }}>
          <div style={{ fontSize: 11, fontWeight: 'bold', color: 'var(--text-muted)', marginBottom: 4 }}>
            CONNECTOR URL
          </div>
          {MCP_URL ? (
            <code style={{ fontSize: 14, wordBreak: 'break-all' }}>{MCP_URL}</code>
          ) : (
            <span style={{ fontSize: 13, color: 'var(--red)' }}>
              Not configured — VITE_MCP_CONNECTOR_URL is missing from this build.
            </span>
          )}
        </div>

        <ol style={{ margin: 0, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <li>Open <strong>Claude</strong> → <strong>Settings</strong> → <strong>Connectors</strong>.</li>
          <li>Click <strong>Add custom connector</strong>.</li>
          <li>Paste in the connector URL above.</li>
          <li>Claude will redirect you to log in with your normal company account.</li>
          <li>Approve the requested permissions (<code>leads:read</code>, <code>events:read</code>).</li>
          <li>Done — Claude can now query internal data through the connector.</li>
        </ol>

        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 8,
          marginTop: 20,
          padding: '10px 14px',
          background: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 8,
          fontSize: 12,
          color: 'var(--text-muted)',
        }}>
          <KeyRound size={14} style={{ flexShrink: 0, marginTop: 2 }} />
          <span>
            This uses your existing employee login. There's no separate signup, and no secret
            key or token to enter or manage.
          </span>
        </div>
      </div>
    </div>
  )
}
